import { combineReducers } from 'redux';

import { authReducer } from './auth/reducer';
import { usersReducer } from './users/reducer';
import { rolesReducer } from './roles/reducer';
import { projectsReducer } from './projects/reducer';
import { searchProjectsReducer } from './searchProjects/reducer';
import { activeSearchProjectReducer } from './activeSearchProject/reducer';
import { endpointsReducer } from './endpoints/reducer';
import { connectionsReducer } from './connections/reducer';
import { authKeysReducer } from './authKeys/reducer';
import { toastsReducer } from './toasts/reducer';
import { activeAuthKeyReducer } from './activeAuthKey/reducer';
import { activeConnectionReducer } from './activeConnection/reducer';
import { activeEndpointReducer } from './activeEndpoint/reducer';
import { activeUserReducer } from './activeUser/reducer';
import { activeProjectReducer } from './activeProject/reducer';
import { activeVariableReducer } from './activeVariable/reducer';
import { invitesReducer } from './invites/reducer';
import { directoryReducer } from './directory/reducer';
import { errorsReducer } from './errors/reducer';
import { historyReducer } from './history/reducer';
import { trashReducer } from './trash/reducer';
import { databaseSchemeReducer } from './databaseScheme/reducer';
import { variablesReducer } from './variables/reducer';
import { activeChartReducer } from './activeChart/reducer';
import { dashboardsReducer } from './dashboards/reducer';

const appReducer = combineReducers({
  variables: variablesReducer,
  auth: authReducer,
  users: usersReducer,
  roles: rolesReducer,
  projects: projectsReducer,
  searchProjects: searchProjectsReducer,
  activeSearchProject: activeSearchProjectReducer,
  endpoints: endpointsReducer,
  authKeys: authKeysReducer,
  history: historyReducer,
  connections: connectionsReducer,
  toasts: toastsReducer,
  trash: trashReducer,
  activeAuthKey: activeAuthKeyReducer,
  activeConnection: activeConnectionReducer,
  activeEndpoint: activeEndpointReducer,
  activeChart: activeChartReducer,
  dashboard: dashboardsReducer,
  activeUser: activeUserReducer,
  activeProject: activeProjectReducer,
  activeVariable: activeVariableReducer,
  invites: invitesReducer,
  directory: directoryReducer,
  errors: errorsReducer,
  databaseScheme: databaseSchemeReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_USER_SUCCESS') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
